// Notification Severity Types
export const ERROR = "ERROR";
